import './index.css'

function MediaAndText({text,heading,image,reversed}){
    return <div className={reversed ? 'media-and-text reversed' : 'media-and-text'}>
    <div className='text-container'>
    <h2 className='big-text'>{heading}</h2>
    <p className='small-text'>{text}</p>
    </div>
    <img alt={heading} src={image}></img>
    </div>
}

export default MediaAndText